import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminEditDocument from "../../Components/Admin/AdminEditDocument";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditDocumentPage = () => {
  return (

    <AdminEditDocument />

  );
};

export default AdminEditDocumentPage;